export const iconFontAwesomeSecurityPersonShelter = (
	<i className="fa-solid fa-person-shelter"></i>
);
